require('public/js/elements/overlay-spinner');

const FIT_PART_RECOMMENDATION_EVENT_PREFIX = 'fit_part_recommendation';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	(function BrowseProductsThatFitModule() {
		$onReady({
			rp$, window,
			label: 'browse_fitting_products',
			fn: function () {
				var tracking_page = (window.tracking.page || 'other');
				const productDetail = globalThis.tracking?.ec?.product_detail;

				// Track when a person selects the wrong vehicle on a product page.
				var $partFitmentInfoElement = rp$('#part-fitment-info');
				if ($partFitmentInfoElement.length) {
					var data = $partFitmentInfoElement.data('fitment-info');
					if (data === 'part-doesnt-fit') {
						window.rp_app.track.track_event(['ProductPageWrongCarSelected', 'WrongCarSelected', tracking_page]);
					}
				}

				// Track when a person clicks a suggested product when they have the wrong vehicle selected.
				var $productLink = rp$('.suggested-products');
				if ($productLink.length) {
					$productLink.on('click', function (e) {
						window.rp_app.track.track_event(['ProductPageWrongCarSelected', 'SuggestedProductClick', tracking_page]);
						
						const $card = rp$(this);
						const basePayload = {
							item_id: productDetail?.id,
							item_name: productDetail?.name,
							suggested_item_id: $card.find('[data-test-id="suggested-product__sku"]').first().text().trim(),
							suggested_item_name: $card.find('[data-test-id="suggested-product__name"]').first().text().trim() || undefined,
						};

						const isAddToCart = e.target.closest('.fitting-product-add-cart');
						const $link = rp$(e.target).closest('a.suggested-product-link');

						const payload = {
							...basePayload,
							click_target: isAddToCart ? 'add_to_cart' : 'product_link',
							link_url: $link.length ? $link.attr('href') : null,
						};

						globalThis.rp_app.track.track_ec_general(`${FIT_PART_RECOMMENDATION_EVENT_PREFIX}_click`, payload);
					});
				}

				// Track when a person clicks the add to cart button for a suggested product when they have the wrong vehicle selected.
				var $addCartButton = rp$('.fitting-product-add-cart');
				if ($addCartButton.length) {
					$addCartButton.on('click', function (e) {
						window.rp_app.track.track_event(['ProductPageWrongCarSelected', 'SuggestedProductAddToCartClick', tracking_page]);
					});
				}

				var $productsThatFitElement = rp$('.fitting-products');
				const fittingProductCount = $productsThatFitElement.children().length;
				let redesign = rp$('.browse-fitting-products').hasClass('redesign');
				$productsThatFitElement.owlCarousel({
					margin: 10,
					nav: true,
					navText: false,
					dots: !redesign,
					responsive: {
						0: {
							items: 1
						},
						640: {
							items: redesign ? 2 : 1
						},
						767: {
							items: 1
						}
					},
					loop: true,
				});

				rp$('.browse-fitting-products').attr('hidden', false);
				rp$('.browse-fitting-products').show(500, () => {
					rp$('.fitting-products').attr('hidden', false);
					rp$('.fitting-products-header').attr('hidden', false);
					$productsThatFitElement.trigger('refresh.owl.carousel');

					if (fittingProductCount > 0) {
						const payload = {
							item_id: productDetail?.id,
							item_name: productDetail?.name,
							count: fittingProductCount,
						};
						globalThis.rp_app.track.track_ec_general(`${FIT_PART_RECOMMENDATION_EVENT_PREFIX}_view`, payload);
					}
				});
			}
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
